import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import illustrationImg from './assets/lock_closed.svg';
import messages from './messages.tsx';

type Props = {
	projectKey: ProjectKey;
};

const getProjectUrl = (projectKey: ProjectKey) => `/browse/${projectKey}`;

export const NoPermissionPage = ({ projectKey }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<PageWrapper>
			<BodyWrapper>
				<DescriptionWrapper>
					<Box xcss={titleWrapperStyles}>
						<Heading size="large">{formatMessage(messages.title)}</Heading>
					</Box>
					<Description>{formatMessage(messages.description)}</Description>
					<Button appearance="primary" href={getProjectUrl(projectKey)}>
						{formatMessage(messages.goBackToProject)}
					</Button>
				</DescriptionWrapper>
				<IllustrationWrapper src={illustrationImg} aria-hidden />
			</BodyWrapper>
		</PageWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PageWrapper = styled.div({
	width: '100%',
	height: '100%',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BodyWrapper = styled.div({
	display: 'flex',
	width: '592px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DescriptionWrapper = styled.div({
	flex: 1,
	paddingRight: token('space.800'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IllustrationWrapper = styled.img({
	width: '112px',
});

const titleWrapperStyles = xcss({
	marginBottom: 'space.200',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text'),
	marginBottom: token('space.200'),
});
